import _Vue from 'vue';
import WxOpenAppTipTemplate from './WxOpenAppTip.vue';

export default {
  install(Vue: typeof _Vue) {
    console.log('wx plugin running');
    Vue.prototype.$openAppTip = () => {
      const mountEl = document.querySelector('#WxOpenAppTip')!;
      const WxOpenAppTipConstructor = Vue.extend(WxOpenAppTipTemplate);
      const WxOpenAppTipInstance = new WxOpenAppTipConstructor().$mount();
      (WxOpenAppTipInstance as any).trigger();

      if (mountEl) {
        mountEl.parentElement!.removeChild(mountEl); // 避免重复挂载UI组件至DOM
      }
      document.body.appendChild(WxOpenAppTipInstance.$el);
    };
  },
};
